<template>
  <div class="ncrm-import-provenance">
    <v-alert type="info" density="comfortable" class="mb-4">
      {{ $t("ncrm.importWizard.provenance.intro") }}
    </v-alert>

    <v-select
      :model-value="modelValue.sourceCategory"
      :items="categoryOptions"
      :label="$t('ncrm.importWizard.provenance.categoryLabel')"
      :hint="$t('ncrm.importWizard.provenance.categoryHint')"
      :error-messages="categoryError ? [categoryError] : []"
      persistent-hint
      class="mb-4"
      @update:model-value="update('sourceCategory', $event)"
    />

    <v-textarea
      :model-value="modelValue.sourceDescription"
      :label="descriptionLabel"
      :hint="$t('ncrm.importWizard.provenance.descriptionHint')"
      :error-messages="descriptionError ? [descriptionError] : []"
      persistent-hint
      rows="2"
      auto-grow
      counter="500"
      maxlength="500"
      class="mb-4"
      @update:model-value="update('sourceDescription', $event)"
    />

    <v-checkbox
      :model-value="modelValue.subjectsAlreadyInformed"
      :label="$t('ncrm.importWizard.provenance.alreadyInformedLabel')"
      :hint="$t('ncrm.importWizard.provenance.alreadyInformedHint')"
      persistent-hint
      density="comfortable"
      class="mb-2"
      @update:model-value="update('subjectsAlreadyInformed', $event)"
    />

    <v-alert
      v-if="showInformationNotice"
      type="warning"
      density="comfortable"
      class="mt-4"
    >
      {{ $t("ncrm.importWizard.provenance.informationDue") }}
    </v-alert>
  </div>
</template>

<script>
import {
  SOURCE_CATEGORIES,
  isProvenanceComplete,
  requiresSubjectInformation,
} from "@/components/ncrm/contacts/importProvenance.mjs";

// DPIA acțiunea A3 / B1 — întrebarea despre proveniența unui import.
// Logica pură (liste, validare) stă în `importProvenance.mjs`, ca să poată fi
// testată fără a monta componenta și comparată cu oglinda ei din backend.
export default {
  name: "NcrmImportProvenanceStep",
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    showErrors: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    categoryOptions() {
      return SOURCE_CATEGORIES.map((value) => ({
        value,
        title: this.$t(`ncrm.importWizard.provenance.categories.${value}`),
      }));
    },
    descriptionRequired() {
      return this.modelValue.sourceCategory === "other";
    },
    descriptionLabel() {
      const base = this.$t("ncrm.importWizard.provenance.descriptionLabel");
      return this.descriptionRequired ? `${base} *` : base;
    },
    categoryError() {
      if (!this.showErrors || this.modelValue.sourceCategory) return "";
      return this.$t("ncrm.importWizard.provenance.categoryRequired");
    },
    descriptionError() {
      if (!this.showErrors || isProvenanceComplete(this.modelValue)) return "";
      if (!this.descriptionRequired) return "";
      return this.$t("ncrm.importWizard.provenance.descriptionRequired");
    },
    showInformationNotice() {
      return requiresSubjectInformation(this.modelValue);
    },
  },
  methods: {
    update(field, value) {
      this.$emit("update:modelValue", { ...this.modelValue, [field]: value });
    },
  },
};
</script>
